/**
 * Defines the constants used by the Events module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 * @author DJ Kim <DJ@thebrandingfarm.com>
 */
export const VUEX_EVENTS_GET_REQUEST                  = 'VUEX_EVENTS_GET_REQUEST'
export const VUEX_EVENTS_GET_SUCCESS                  = 'VUEX_EVENTS_GET_SUCCESS'
export const VUEX_EVENTS_GET_FAILURE                  = 'VUEX_EVENTS_GET_FAILURE'
export const VUEX_EVENTS_SET_APPROVED                 = 'VUEX_EVENTS_SET_APPROVED'
export const VUEX_EVENTS_APPLY_FILTERS                = 'VUEX_EVENTS_APPLY_FILTERS'
export const VUEX_EVENTS_CLEAR_FILTERS                = 'VUEX_EVENTS_CLEAR_FILTERS'
export const VUEX_EVENTS_APPLY_STATUS_FILTER          = 'VUEX_EVENTS_APPLY_STATUS_FILTER'
export const VUEX_EVENTS_APPLY_PROGRESS_FILTER        = 'VUEX_EVENTS_APPLY_PROGRESS_FILTER'
export const VUEX_EVENTS_APPLY_TYPE_FILTER            = 'VUEX_EVENTS_APPLY_TYPE_FILTER'
export const VUEX_EVENTS_APPLY_DEPARTMENT_FILTER      = 'VUEX_EVENTS_APPLY_DEPARTMENT_FILTER'
export const VUEX_EVENTS_APPLY_CREATIVE_ROUND_FILTER  = 'VUEX_EVENTS_APPLY_CREATIVE_ROUND_FILTER'
export const VUEX_EVENTS_SYNC_PAGINATION              = 'VUEX_EVENTS_SYNC_PAGINATION'

export const VUEX_EVENT_GET_REQUEST                   = 'VUEX_EVENT_GET_REQUEST'
export const VUEX_EVENT_GET_SUCCESS                   = 'VUEX_EVENT_GET_SUCCESS'
export const VUEX_EVENT_GET_EVENTS_SUCCESS            = 'VUEX_EVENT_GET_EVENTS_SUCCESS'
export const VUEX_EVENT_GET_FILES_SUCCESS             = 'VUEX_EVENT_GET_FILES_SUCCESS'
export const VUEX_EVENT_GET_FAILURE                   = 'VUEX_EVENT_GET_FAILURE'
export const VUEX_EVENT_UPDATE_INIT                   = 'VUEX_EVENT_UPDATE_INIT'
export const VUEX_EVENT_UPDATE_APPLY_TEMPLATE         = 'VUEX_EVENT_UPDATE_APPLY_TEMPLATE'
export const VUEX_EVENT_UPDATE_PROP                   = 'VUEX_EVENT_UPDATE_PROP'
export const VUEX_EVENT_UPDATE_REQUEST                = 'VUEX_EVENT_UPDATE_REQUEST'
export const VUEX_EVENT_UPDATE_REQUEST_SUCCESS        = 'VUEX_EVENT_UPDATE_REQUEST_SUCCESS' 
export const VUEX_EVENT_UPDATE_REQUEST_FAILURE        = 'VUEX_EVENT_UPDATE_REQUEST_FAILURE'
export const VUEX_EVENT_SAVE_EVENT_NAME                 = 'VUEX_EVENT_SAVE_EVENT_NAME'
export const VUEX_EVENT_ADD_EVENT                     = 'VUEX_EVENT_ADD_EVENT'
export const VUEX_EVENT_REMOVE_EVENT                  = 'VUEX_EVENT_REMOVE_EVENT'

export const VUEX_EVENT_CREATE_INIT                   = 'VUEX_EVENT_CREATE_INIT'
export const VUEX_EVENT_CREATE                        = 'VUEX_EVENT_CREATE'
export const VUEX_EVENT_CREATE_SUCCESS                = 'VUEX_EVENT_CREATE_SUCCESS'
export const VUEX_EVENT_CREATE_FAILURE                = 'VUEX_EVENT_CREATE_FAILURE'
export const VUEX_EVENT_CREATE_UPDATE                 = 'VUEX_EVENT_CREATE_UPDATE'
export const VUEX_EVENT_CREATE_UPDATE_SUCCESS         = 'VUEX_EVENT_CREATE_UPDATE_SUCCESS'
export const VUEX_EVENT_CREATE_UPDATE_FAILURE         = 'VUEX_EVENT_CREATE_UPDATE_FAILURE'
export const VUEX_EVENT_CREATE_APPLY_TEMPLATE         = 'VUEX_EVENT_CREATE_APPLY_TEMPLATE' 
export const VUEX_EVENT_CREATE_UPDATE_PROP            = 'VUEX_EVENT_CREATE_UPDATE_PROP'
export const VUEX_EVENT_CREATE_CANCEL                 = 'VUEX_EVENT_CREATE_CANCEL'
export const VUEX_EVENT_CREATE_HAS_CHANGED            = 'VUEX_EVENT_CREATE_HAS_CHANGED'
export const VUEX_EVENT_CREATE_CLEAR_PROPS_TO_UPDATE  = 'VUEX_EVENT_CREATE_CLEAR_PROPS_TO_UPDATE'

export const VUEX_EVENT_REMOVE                        = 'VUEX_EVENT_REMOVE'
export const VUEX_EVENT_REMOVE_SUCCESS                = 'VUEX_EVENT_REMOVE_SUCCESS'
export const VUEX_EVENT_REMOVE_FAILURE                = 'VUEX_EVENT_REMOVE_FAILURE'

